import { useState } from 'react'
import { FastlyImage } from '@components/common/image'
import { CyclicCarousel } from '@components/common/cyclic-carousel'
import { HeartIcon } from '@heroicons/react/24/solid'

const N = 12

const TeacherMomentCard = ({
  index,
  currentSlide,
}: {
  index: number
  currentSlide: number
}) => {
  const shouldHide = () => {
    if (currentSlide <= 1 && index === N - 1) return true
    if (currentSlide >= N - 2 && index === 0) return true
    return false
  }

  return (
    <div
      className={`box-border px-5 sm:px-12 md:px-0 h-full transition-opacity duration-500 ${
        shouldHide() ? 'opacity-0 pointer-events-none' : ''
      }`}
    >
      <div className="relative w-full h-full overflow-hidden shadow-lg rounded-xl">
        <FastlyImage
          src={`images/teacher-lp/culture/${index + 1}.png`}
          alt={`Teacher community moment ${index + 1}`}
          width={560}
          height={315}
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  )
}

const TeacherCommunity = () => {
  const [currentSlide, setCurrentSlide] = useState(1)

  return (
    <div className="px-5 py-12 lg:py-16 bg-orange-100">
      <div className="container mx-auto relative">
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <h2 className="pb-3 text-2xl text-center text-grey lg:text-4xl font-600">
            Our teacher community
          </h2>
          <p className="text-lg text-grey mb-6">
            Teaching at Codingal is not just about classes. It is a community
            where teachers share wins, learn from each other, and feel supported
            through every stage of the journey.
          </p>

          <div className="flex justify-center items-center gap-4 md:gap-8 flex-wrap text-grey-800">
            <div className="flex items-center gap-2">
              <span className="text-2xl p-1 bg-yellow-200 rounded-xl" />
              <p className="text-base lg:text-lg">Moments captured</p>
            </div>
            <span className="text-2xl h-1 w-1 bg-grey-600 rounded-xl hidden sm:block" />
            <div className="flex items-center gap-2">
              <span className="h-5 w-5 text-orange-600">
                <HeartIcon />
              </span>
              <p className="text-base lg:text-lg">1000+ active teachers</p>
            </div>
          </div>
        </div>

        <div className="relative md:px-16">
          <CyclicCarousel
            className="teacher-community-carousel"
            onSlideChange={setCurrentSlide}
          >
            {Array.from({ length: N }, (_, index) => (
              <TeacherMomentCard
                key={index}
                index={index}
                currentSlide={currentSlide}
              />
            ))}
          </CyclicCarousel>
        </div>
      </div>
      <style jsx global>{`
        .teacher-community-carousel .slide {
          height: 297px;
          width: 432px;
          max-height: 297px;
          max-width: 432px;
        }

        @media (max-width: 767px) {
          .teacher-community-carousel .slide {
            height: auto;
            max-height: none;
            aspect-ratio: 16 / 9;
          }
        }
      `}</style>
    </div>
  )
}

export default TeacherCommunity
